import { render, staticRenderFns } from "./gigya-screen.vue?vue&type=template&id=1b1c3a5a&scoped=true"
import script from "./gigya-screen.vue?vue&type=script&lang=js"
export * from "./gigya-screen.vue?vue&type=script&lang=js"
import style0 from "./gigya-screen.vue?vue&type=style&index=0&id=1b1c3a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c3a5a",
  null
  
)

export default component.exports